import { countryCodes } from "@Components/LeadFormModal/data/countryCodes";
import getParsedLocalStorageData from "@Components/LeadFormModal/helpers/getParsedLocalStorageData";

// localstorage update
const setLeadPersonalDetails = (loggedInUserData: any) => {
  const phoneCode = loggedInUserData?.phone_details?.country_code;
  const codeWithCountry = countryCodes.find((code) => code.label === `+${phoneCode}`);
  const phone = loggedInUserData?.phone?.slice(phoneCode?.length);

  const personalData = {
    ...(loggedInUserData?.name && { "user_details/name": loggedInUserData?.name }),
    "user_details/email": loggedInUserData?.email,
    ...(codeWithCountry?.label && { "user_details/phone_code": codeWithCountry?.label }),
    ...(phone && { "user_details/phone": +phone }),
  };

  if (
    !__SERVER__ &&
    typeof window !== undefined &&
    typeof window.localStorage !== undefined &&
    typeof localStorage.setItem === "function"
  ) {
    const savedPersonalData = getParsedLocalStorageData("lead-form-one-saved-data");
    localStorage.setItem(
      "lead-form-one-saved-data",
      JSON.stringify({ ...savedPersonalData, ...personalData }),
    );
  }
};

export default setLeadPersonalDetails;
